var map = {
	"./OK.svg": "7fe6",
	"./OK_blue.svg": "aaec",
	"./Triangle.svg": "44d0",
	"./admin_icon.svg": "b943",
	"./admin_icon_white.svg": "a5c7",
	"./api_icon.svg": "121c",
	"./btn_servik.svg": "9cab",
	"./btn_servik_active.svg": "16dc",
	"./btn_settings.svg": "5cd3",
	"./btn_settings_active.svg": "641b",
	"./buzzztv_logo.svg": "a086",
	"./company_logos/Above_and_Beyond.svg": "2750",
	"./company_logos/Applied_Material.svg": "e35d",
	"./company_logos/Appsflyer.svg": "0d9c",
	"./company_logos/Ariel_University.svg": "c1ba",
	"./company_logos/Assuta_Hospital.svg": "7039",
	"./company_logos/Audiocodes.svg": "3c7d",
	"./company_logos/Ayalon.svg": "85e4",
	"./company_logos/Bank_Hapoalim.svg": "e132d",
	"./company_logos/Bank_Israel.svg": "a4e6",
	"./company_logos/Beit_Bakfar.svg": "41c2",
	"./company_logos/Beit_Gazit.svg": "fab7",
	"./company_logos/Bet_Key.svg": "d18a",
	"./company_logos/Big.svg": "0702",
	"./company_logos/Carlsberg.svg": "161d",
	"./company_logos/Carmel_Hospital.svg": "df03",
	"./company_logos/Crown_Plaza_Hotel.svg": "4973",
	"./company_logos/Elbit.svg": "4204",
	"./company_logos/Electra.svg": "53f8",
	"./company_logos/Gilat_Communications.svg": "d8c2",
	"./company_logos/Haamek_Hospital.svg": "39e7",
	"./company_logos/Hp.svg": "17b2",
	"./company_logos/ISS.svg": "2373",
	"./company_logos/Ichilov_Medical_Center.svg": "d2e3",
	"./company_logos/Intel.svg": "1d0d",
	"./company_logos/Isracard.svg": "eaa0",
	"./company_logos/Israel_Aerospace_Industries.svg": "c7b2",
	"./company_logos/Israel_Airports_Authority.svg": "7ca8",
	"./company_logos/Israel_Chemicals_Limited.svg": "b879",
	"./company_logos/Israel_Electric_Corporation.svg": "0d4a",
	"./company_logos/Jll.svg": "f3ca",
	"./company_logos/Macabi.svg": "cf8c",
	"./company_logos/Mayanei_Hayeshua_Mc.svg": "b9ba",
	"./company_logos/Meir_Hospital.svg": "f94d",
	"./company_logos/Minhal_cologe.svg": "00e6",
	"./company_logos/Ministry_of_Aliyah_and Integration.svg": "5232",
	"./company_logos/Mister_Bit.svg": "c0d4",
	"./company_logos/Mivne_Group.svg": "4476",
	"./company_logos/Municipality_Tel_Aviv.svg": "2fb2",
	"./company_logos/Nice.svg": "5946",
	"./company_logos/Office_Depot.svg": "e3d2",
	"./company_logos/One_hundred_&_twenty.svg": "ebfa",
	"./company_logos/Philips.svg": "061a",
	"./company_logos/Sheba_Hospital.svg": "7139",
	"./company_logos/Soroka_Hospital.svg": "fab5",
	"./company_logos/Tel_Aviv_Universty.svg": "8b63",
	"./company_logos/Teva_Pharmaceutical.svg": "3b7d",
	"./company_logos/Verint.svg": "a818",
	"./company_logos/Weizmann_Institute.svg": "a246",
	"./company_logos/Yoseftal_Hospital.svg": "7c71",
	"./company_logos/Zim.svg": "d86a",
	"./delete-icon.svg": "6717",
	"./devices/cloud_download.svg": "b6e4",
	"./devices/device_info.svg": "d005",
	"./devices/device_settings.svg": "db56",
	"./devices/errors_list.svg": "87d2",
	"./devices/image_icon.svg": "bdb5",
	"./devices/phone arrow.svg": "907f",
	"./devices/phone_arrow.svg": "4796",
	"./devices/team_viewer.svg": "a615",
	"./duplicate_icon.svg": "6d46",
	"./edit-icon.svg": "c3a2",
	"./email_icon.svg": "c6e1",
	"./exit_full_screen.svg": "bf63",
	"./eye-selected.svg": "53e5",
	"./eye_white.svg": "e332",
	"./filter.svg": "5ee4",
	"./filterGrey.svg": "a4ed",
	"./finger_clicking.svg": "09c1",
	"./full_screen.svg": "5f10",
	"./icon_home.svg": "9273",
	"./icon_password.svg": "24c8",
	"./icon_user.svg": "97fc",
	"./languages_flags/ar.svg": "48c6",
	"./languages_flags/cs.svg": "01ea",
	"./languages_flags/en.svg": "7347",
	"./languages_flags/es.svg": "fa30",
	"./languages_flags/he.svg": "ba87",
	"./languages_flags/ka.svg": "b394",
	"./languages_flags/ml.svg": "f167",
	"./languages_flags/nl.svg": "dfa3",
	"./languages_flags/pl.svg": "a01f",
	"./languages_flags/pt.svg": "f689",
	"./languages_flags/ro.svg": "e46f",
	"./languages_flags/ru.svg": "40106",
	"./languages_flags/si.svg": "dc41",
	"./languages_flags/sk.svg": "aba3",
	"./languages_flags/uk.svg": "abb7",
	"./man.svg": "7a0b",
	"./offline.svg": "3f98",
	"./pad_warning_blue.svg": "4bb4",
	"./performance/avg_score-icon.svg": "9c57",
	"./performance/calendar.svg": "70d5",
	"./performance/cleandex_calls-icon.svg": "c90f",
	"./performance/cleaner.svg": "dc1b",
	"./performance/cleaner_arrival-icon.svg": "10f8",
	"./performance/cleaner_arrival_white-icon.svg": "c3aa",
	"./performance/clock-light.svg": "42e5",
	"./performance/clock.svg": "5315",
	"./performance/clock_white.svg": "83bf",
	"./performance/colors.svg": "27d7",
	"./performance/csv-export.svg": "a6e5",
	"./performance/dollar.svg": "32c5",
	"./performance/green_arrow.svg": "be70",
	"./performance/icons-complaint.svg": "529a",
	"./performance/icons-complaint_blue.svg": "e7c8",
	"./performance/icons-complaint_orange.svg": "6676",
	"./performance/icons-complaint_white.svg": "4a11",
	"./performance/icons-counter_calls.svg": "3b1e",
	"./performance/icons-timer.svg": "080f",
	"./performance/icons-timer_white.svg": "61d2",
	"./performance/icons-visits.svg": "6f8d",
	"./performance/icons-visits_white.svg": "8e21",
	"./performance/maintenance-arrivals_purple.svg": "33c0",
	"./performance/man-exposures.svg": "df1d",
	"./performance/man_grey.svg": "3aab",
	"./performance/man_white.svg": "ebeb",
	"./performance/missed-sla.svg": "4a07",
	"./performance/no-SLA.svg": "eb63",
	"./performance/pdf-export.svg": "b52f",
	"./performance/red_arrow.svg": "26b1",
	"./performance/report-export.svg": "1651",
	"./performance/score-trend-up.svg": "ba2d",
	"./performance/sla-green.svg": "9af6",
	"./performance/supervisor_arrival-icon.svg": "4366",
	"./performance/toilet-paper-solid.svg": "7a39",
	"./performance/toilet-side.svg": "93ad",
	"./performance/toilet.svg": "c196",
	"./performance/trend_black.svg": "5dcd",
	"./performance/trend_white.svg": "2468",
	"./performance/warning.svg": "3c6b",
	"./performance/white_arrow.svg": "f6c4",
	"./performance/wiping-sprayer.svg": "ea7f",
	"./performance/wiping-swipe-for-floors-green.svg": "171c",
	"./performance/wiping-swipe-for-floors-orange.svg": "37b5",
	"./performance/wiping-swipe-for-floors-purple.svg": "8df9",
	"./performance/wiping-swipe-for-floors-white.svg": "e67d",
	"./performance/wiping-swipe-for-floors.svg": "96ce",
	"./performance/woman_grey.svg": "fb40",
	"./performance/woman_white.svg": "eab4",
	"./preview_arrival.svg": "132e",
	"./push-pin-slash.svg": "452a",
	"./push-pin.svg": "dd10",
	"./qr_code.svg": "65a9",
	"./real_time_icons/OK.svg": "9b79",
	"./real_time_icons/warning_orange.svg": "51bc",
	"./room-info.svg": "5fdb",
	"./servik_icons/bad_smell.svg": "6a31",
	"./servik_icons/cleaned_floor.svg": "9fe7",
	"./servik_icons/cleaned_mirro.svg": "f219",
	"./servik_icons/cleaned_shower.svg": "e080",
	"./servik_icons/cleaned_sink.svg": "65eb",
	"./servik_icons/cleaned_stainless_steel.svg": "3aae",
	"./servik_icons/cleaned_toilet.svg": "35ca",
	"./servik_icons/cleaner.svg": "97fe",
	"./servik_icons/cleaner_arrived.svg": "09bc",
	"./servik_icons/cleaning.svg": "87b7",
	"./servik_icons/coffee_tea.svg": "e329",
	"./servik_icons/counter.svg": "3327",
	"./servik_icons/counter_handycap.svg": "f5aa",
	"./servik_icons/counter_men.svg": "4c96",
	"./servik_icons/counter_woman.svg": "8dac",
	"./servik_icons/dirty_floor.svg": "36cb",
	"./servik_icons/dirty_lavatory_seat.svg": "f0dd",
	"./servik_icons/dirty_mirror.svg": "660b",
	"./servik_icons/dirty_shower.svg": "e20c",
	"./servik_icons/dirty_sink.svg": "c64a",
	"./servik_icons/dirty_stainless_steel.svg": "8f99",
	"./servik_icons/disposable_dishes.svg": "b8e6",
	"./servik_icons/english.svg": "2ff5",
	"./servik_icons/español.svg": "7bd4",
	"./servik_icons/excellent.svg": "b895",
	"./servik_icons/fixed_blockage.svg": "8f4d",
	"./servik_icons/fixed_broken_toilet.svg": "b52c",
	"./servik_icons/fixed_door.svg": "047e",
	"./servik_icons/fixed_fluid_taps.svg": "7c65",
	"./servik_icons/fixed_lightning.svg": "5ab2",
	"./servik_icons/fixed_mirro.svg": "9c1f",
	"./servik_icons/fixed_shower.svg": "de74",
	"./servik_icons/fixed_sink.svg": "fe6b",
	"./servik_icons/fixed_stainless_steel.svg": "8e4b",
	"./servik_icons/français.svg": "2fea",
	"./servik_icons/full_garbage_can.svg": "1eed",
	"./servik_icons/good.svg": "28fa",
	"./servik_icons/italiano.svg": "31e8e",
	"./servik_icons/light.svg": "f3d3",
	"./servik_icons/like.svg": "0806",
	"./servik_icons/maintenance.svg": "00a1",
	"./servik_icons/maintenance_fixed.svg": "bb40",
	"./servik_icons/maintenance_problem.svg": "1cf2",
	"./servik_icons/missing_paper_towel.svg": "1330",
	"./servik_icons/missing_soap.svg": "d7ef",
	"./servik_icons/missing_toilet_paper.svg": "06c6",
	"./servik_icons/needs_Improvement.svg": "a181",
	"./servik_icons/not_good.svg": "beb2",
	"./servik_icons/paper_towel.svg": "8c31",
	"./servik_icons/português.svg": "d34c",
	"./servik_icons/problem_blockage.svg": "fd05",
	"./servik_icons/problem_broken_toilet.svg": "0ae5",
	"./servik_icons/problem_fluid_taps.svg": "8a09",
	"./servik_icons/problem_lightning.svg": "7a34",
	"./servik_icons/problem_mirro.svg": "b81c",
	"./servik_icons/problem_paper_dispenser.svg": "bf84",
	"./servik_icons/problem_shower.svg": "5087",
	"./servik_icons/problem_soap_dispenser.svg": "be74",
	"./servik_icons/problem_stainless_steel.svg": "15c0",
	"./servik_icons/taps.svg": "8c0a",
	"./servik_icons/toilet_seat.svg": "8f5a",
	"./servik_icons/very_good.svg": "4a48",
	"./servik_survey_icons/Problem_fluid_Taps.svg": "b815",
	"./servik_survey_icons/bad_smell.svg": "f971",
	"./servik_survey_icons/blockage.svg": "545d",
	"./servik_survey_icons/dirty_floor.svg": "a644a",
	"./servik_survey_icons/dirty_labatory_seat.svg": "7479",
	"./servik_survey_icons/door.svg": "bfd7",
	"./servik_survey_icons/light_bulb.svg": "0181",
	"./servik_survey_icons/like.svg": "648f",
	"./servik_survey_icons/maintenance.svg": "aae4",
	"./servik_survey_icons/missing_paper_towel.svg": "f9ec",
	"./servik_survey_icons/missing_soap.svg": "438b",
	"./servik_survey_icons/missing_toilet_paper.svg": "4f48",
	"./site_icon.svg": "ad00",
	"./start-icon.svg": "f1ba",
	"./suggestion/blue_side_arrow.svg": "9f61",
	"./survey/align-center.svg": "3097",
	"./survey/align-left.svg": "5bdb",
	"./survey/align-right.svg": "b275",
	"./survey/arrow_left.svg": "fc3b",
	"./survey/arrow_left_dark.svg": "8e53",
	"./survey/arrow_right.svg": "272c",
	"./survey/checklist-icon.svg": "78f0",
	"./survey/checkmark_disabled.svg": "c1be",
	"./survey/checkmark_enabled.svg": "c5bd",
	"./survey/edit-selected.svg": "713d",
	"./survey/edit-white.svg": "6f94",
	"./survey/edit.svg": "cbb4",
	"./survey/eye-selected.svg": "a822",
	"./survey/eye.svg": "2ce8",
	"./survey/font-size-decrease-icon.svg": "0247",
	"./survey/font-size-increase-icon.svg": "d94c",
	"./survey/icon_shapes/arrow_down.svg": "b8b5",
	"./survey/icon_shapes/circle.svg": "4477",
	"./survey/icon_shapes/heart.svg": "5134",
	"./survey/icon_shapes/heart_filled.svg": "a9fb",
	"./survey/icon_shapes/rounded.svg": "25e6",
	"./survey/icon_shapes/square.svg": "5916",
	"./survey/icon_shapes/star.svg": "433d",
	"./survey/icon_shapes/star_filled.svg": "5d2b",
	"./survey/icon_shapes/thumbs_up.svg": "c771",
	"./survey/icon_shapes/thumbs_up_filled.svg": "5766",
	"./survey/icon_shapes/transparent-circle.svg": "da38",
	"./survey/left-arrow.svg": "6ea3",
	"./survey/right-arrow.svg": "3b11",
	"./survey/servik_icons/cleaned/1.cleaned_floor.svg": "93a2",
	"./survey/servik_icons/cleaned/2.cleaned_toilet.svg": "722f",
	"./survey/servik_icons/cleaned/3.cleaned_shower.svg": "7ab3",
	"./survey/servik_icons/cleaned/4.cleaned_sink.svg": "699c",
	"./survey/servik_icons/cleaned/5.cleaned_mirro.svg": "38cf",
	"./survey/servik_icons/cleaned/6.cleaned_stainless_steel.svg": "af8c",
	"./survey/servik_icons/counter/45.people_counter.svg": "8faa",
	"./survey/servik_icons/counter/50.counter.svg": "efb4",
	"./survey/servik_icons/counter/51.counter_men.svg": "612b",
	"./survey/servik_icons/counter/52.counter_woman.svg": "e3bd",
	"./survey/servik_icons/counter/53.counter_handycap.svg": "7c04",
	"./survey/servik_icons/fixed/192.fixed_soap_dispenser.svg": "0f4d",
	"./survey/servik_icons/fixed/193.fixed_paper_dispenser.svg": "521a",
	"./survey/servik_icons/fixed/194.fixed_coffee_machine.svg": "f29f",
	"./survey/servik_icons/fixed/195.fixed_water_bar.svg": "73b1",
	"./survey/servik_icons/fixed/27.fixed_shower.svg": "72e2",
	"./survey/servik_icons/fixed/28.fixed_sink.svg": "0781",
	"./survey/servik_icons/fixed/29.fixed_mirro.svg": "65b2",
	"./survey/servik_icons/fixed/30.fixed_stainless_steel.svg": "f388",
	"./survey/servik_icons/fixed/31.fixed_blockage.svg": "d783",
	"./survey/servik_icons/fixed/32.fixed_door.svg": "6874",
	"./survey/servik_icons/fixed/33.fixed_fluid_taps.svg": "9ea5",
	"./survey/servik_icons/fixed/34.fixed_lightning.svg": "1c9b",
	"./survey/servik_icons/fixed/35.fixed_broken_toilet.svg": "d87f",
	"./survey/servik_icons/food/170.dining_room.svg": "ebd7",
	"./survey/servik_icons/food/171.food_variety.svg": "3029",
	"./survey/servik_icons/food/172.quality_of_the_food.svg": "5928",
	"./survey/servik_icons/food/173.amount_of_the_food.svg": "f687",
	"./survey/servik_icons/food/174.quality_of_cooking.svg": "93e3",
	"./survey/servik_icons/food/175.side_courses.svg": "4e91",
	"./survey/servik_icons/food/176.meat.svg": "6ac2",
	"./survey/servik_icons/food/177.desserts.svg": "c053",
	"./survey/servik_icons/food/178.vegetarian.svg": "3a59",
	"./survey/servik_icons/food/179.salad_bar.svg": "5264",
	"./survey/servik_icons/food/180.main_courses.svg": "568a",
	"./survey/servik_icons/food/181.service.svg": "7eb3",
	"./survey/servik_icons/food/182.dining_room_cleanlines.svg": "b3b7",
	"./survey/servik_icons/food/183.plates_and_cutlery_cleanliness.svg": "dec7",
	"./survey/servik_icons/food/184.product_inventory.svg": "76e7",
	"./survey/servik_icons/food/185.furnichers.svg": "2ccd",
	"./survey/servik_icons/food/186.toilets.svg": "e90c",
	"./survey/servik_icons/kitchen/47.zone_is_dirty.svg": "e726",
	"./survey/servik_icons/kitchen/612.Appliances.svg": "043e",
	"./survey/servik_icons/kitchen/613.Frodktim.svg": "02ed",
	"./survey/servik_icons/kitchen/614.Broken_chair.svg": "0477",
	"./survey/servik_icons/kitchen/615.Broken_abinet.svg": "4573",
	"./survey/servik_icons/kitchen/616.Micro.svg": "ca5c",
	"./survey/servik_icons/kitchen/617.toaster.svg": "8a84",
	"./survey/servik_icons/kitchen/618.Clogged_sink_malfunction.svg": "7c25",
	"./survey/servik_icons/kitchen/619.Coffee_cooling_malfunction.svg": "fde0",
	"./survey/servik_icons/kitchen/620.No_coffee_beans.svg": "1ced",
	"./survey/servik_icons/kitchen/621.Machine_ailure.svg": "9186",
	"./survey/servik_icons/kitchen/622.That_dirty.svg": "f574",
	"./survey/servik_icons/kitchen/623.Dirty_refrigerator.svg": "09eb",
	"./survey/servik_icons/kitchen/624.Dirty_ables.svg": "14bf",
	"./survey/servik_icons/kitchen/625.Dirty_floor.svg": "16da",
	"./survey/servik_icons/kitchen/626.Plates.svg": "62cd",
	"./survey/servik_icons/kitchen/627.Selver_spone.svg": "43be",
	"./survey/servik_icons/kitchen/628.Cold_drinks_cups.svg": "c855",
	"./survey/servik_icons/kitchen/629.Hot_drink_cups.svg": "1cd8",
	"./survey/servik_icons/kitchen/631.problem_sink.svg": "0ec6",
	"./survey/servik_icons/kitchen/632.A_dripping_faucet.svg": "113a",
	"./survey/servik_icons/kitchen/632.problem_lightning.svg": "8d23",
	"./survey/servik_icons/kitchen/81.coffee_tea.svg": "e30f",
	"./survey/servik_icons/kitchen/82.water_bar.svg": "8ce0",
	"./survey/servik_icons/kitchen/83.disposable_dishes.svg": "b261",
	"./survey/servik_icons/language/100.hebrew.svg": "417a",
	"./survey/servik_icons/language/100.עברית.svg": "c086",
	"./survey/servik_icons/language/101.español.svg": "fec0",
	"./survey/servik_icons/language/102.français.svg": "137d",
	"./survey/servik_icons/language/103.english.svg": "6d1a",
	"./survey/servik_icons/language/104.русский.svg": "a6bd",
	"./survey/servik_icons/language/105.italiano.svg": "ea6f",
	"./survey/servik_icons/language/106.አማርኛ.svg": "36d6",
	"./survey/servik_icons/language/107.português.svg": "c8cf",
	"./survey/servik_icons/linked/400.room_link.svg": "96b7",
	"./survey/servik_icons/linked/401.floor_link.svg": "9216",
	"./survey/servik_icons/officials/42.supervise.svg": "7a77",
	"./survey/servik_icons/officials/43.maintenance.svg": "a26d",
	"./survey/servik_icons/officials/44.cleaner.svg": "1581",
	"./survey/servik_icons/officials/45.tag_cleaner.svg": "436d",
	"./survey/servik_icons/officials/46.zone_is_clean.svg": "4e44",
	"./survey/servik_icons/officials/47.zone_is_dirty.svg": "1e98",
	"./survey/servik_icons/officials/48.cleaner_arrived.svg": "ddf4",
	"./survey/servik_icons/officials/49.start_clean_zone.svg": "aab0",
	"./survey/servik_icons/officials/55.maintenance_fixed.svg": "3f39",
	"./survey/servik_icons/officials/56.maintenance_problem.svg": "064c",
	"./survey/servik_icons/officials/59.end_clean_zone.svg": "08ac",
	"./survey/servik_icons/problem/18.problem_shower.svg": "8889",
	"./survey/servik_icons/problem/187.problem_coffee_machine.svg": "bf13",
	"./survey/servik_icons/problem/188.problem_water_bar.svg": "1aab",
	"./survey/servik_icons/problem/19.problem_sink.svg": "9cca",
	"./survey/servik_icons/problem/196.problem_urinals.svg": "094b",
	"./survey/servik_icons/problem/197.blockage_toilet.svg": "470c",
	"./survey/servik_icons/problem/198.appliance_problem.svg": "a551",
	"./survey/servik_icons/problem/199.problem_broken_door.svg": "ee7d",
	"./survey/servik_icons/problem/20.problem_mirro.svg": "3339",
	"./survey/servik_icons/problem/200.problem_broken_door_lock.svg": "3c72",
	"./survey/servik_icons/problem/200.problem_door_lock.svg": "1061",
	"./survey/servik_icons/problem/201.problem_broken_toilet_seat.svg": "c949",
	"./survey/servik_icons/problem/202.problem_broken_niagara.svg": "3720",
	"./survey/servik_icons/problem/203.broken_hand_paper_dispenser_Hand_dryer.svg": "2514",
	"./survey/servik_icons/problem/21.problem_stainless_steel.svg": "3736",
	"./survey/servik_icons/problem/213.problem_bed_smell.svg": "487c",
	"./survey/servik_icons/problem/214.problem_broken_toilet_handle.svg": "e876",
	"./survey/servik_icons/problem/215.problem_handle_door.svg": "94b4",
	"./survey/servik_icons/problem/217.wall_painting.svg": "f73c",
	"./survey/servik_icons/problem/22.problem_blockage.svg": "1817",
	"./survey/servik_icons/problem/220.problem_right_elevator.svg": "a817",
	"./survey/servik_icons/problem/221.problem_left_elevator.svg": "4480",
	"./survey/servik_icons/problem/223.problem_sink_blockage.svg": "c680",
	"./survey/servik_icons/problem/224.electric_problem.svg": "0902",
	"./survey/servik_icons/problem/226.problem_air_condition.svg": "a9dc",
	"./survey/servik_icons/problem/23.problem_door.svg": "4970",
	"./survey/servik_icons/problem/24.problem_fluid_taps.svg": "e7dd",
	"./survey/servik_icons/problem/25.problem_lightning.svg": "a70b",
	"./survey/servik_icons/problem/26.problem_broken_toilet.svg": "08b0",
	"./survey/servik_icons/problem/56.maintenance_problem.svg": "9389",
	"./survey/servik_icons/problem/57.problem_soap_dispenser.svg": "3011",
	"./survey/servik_icons/problem/58.problem_paper_dispenser.svg": "d35e",
	"./survey/servik_icons/problem/88.maintenance.svg": "58c6",
	"./survey/servik_icons/reports/10.dirty_shower.svg": "d5e2",
	"./survey/servik_icons/reports/108.partial_Information.svg": "f028",
	"./survey/servik_icons/reports/11.dirty_sink.svg": "5414",
	"./survey/servik_icons/reports/12.dirty_mirror.svg": "d1af",
	"./survey/servik_icons/reports/13.dirty_stainless_steel.svg": "cc3a",
	"./survey/servik_icons/reports/14.missing_paper_towel.svg": "0424",
	"./survey/servik_icons/reports/15.missing_soap.svg": "a594",
	"./survey/servik_icons/reports/16.missing_toilet_paper.svg": "56ae",
	"./survey/servik_icons/reports/190.dirty_stairs.svg": "4295",
	"./survey/servik_icons/reports/191.missing_toiletries.svg": "baf1",
	"./survey/servik_icons/reports/191.toiletries.svg": "dcde",
	"./survey/servik_icons/reports/204.rug.svg": "d013",
	"./survey/servik_icons/reports/205.tables.svg": "0767",
	"./survey/servik_icons/reports/206.kitchen.svg": "ba3a",
	"./survey/servik_icons/reports/207.air_condition.svg": "01e6",
	"./survey/servik_icons/reports/208.dirty_urinals.svg": "f7a1",
	"./survey/servik_icons/reports/208.problem_urinals.svg": "a202",
	"./survey/servik_icons/reports/209.blockage_toilet.svg": "b91d",
	"./survey/servik_icons/reports/210.hand_dryer.svg": "af9a",
	"./survey/servik_icons/reports/212.non-sticky_carpet.svg": "886c",
	"./survey/servik_icons/reports/216.call_cleaner.svg": "e527",
	"./survey/servik_icons/reports/218.missing_paper.svg": "876c",
	"./survey/servik_icons/reports/219.clean_surface.svg": "304e",
	"./survey/servik_icons/reports/222.missing_hend_sanitizer.svg": "52f7",
	"./survey/servik_icons/reports/225.missing_coffe_tea.svg": "745f",
	"./survey/servik_icons/reports/227.dishwashing.svg": "1847",
	"./survey/servik_icons/reports/228.kitchen_cleanliness.svg": "8512",
	"./survey/servik_icons/reports/229.weekly_cleaning.svg": "d62a",
	"./survey/servik_icons/reports/230.general_arrangement.svg": "5772",
	"./survey/servik_icons/reports/231.meeting_room.svg": "7d2a",
	"./survey/servik_icons/reports/232.refrigerator.svg": "5ba6",
	"./survey/servik_icons/reports/233.kitchen_supplies.svg": "d3b9",
	"./survey/servik_icons/reports/234.toilet_services.svg": "a40d",
	"./survey/servik_icons/reports/235.carousel_door.svg": "b916",
	"./survey/servik_icons/reports/236.desk.svg": "9ce6",
	"./survey/servik_icons/reports/237.compressor.svg": "c464",
	"./survey/servik_icons/reports/238.compressor_rails.svg": "6f25",
	"./survey/servik_icons/reports/239.compressor_drainage.svg": "1685",
	"./survey/servik_icons/reports/240.dust.svg": "bab1",
	"./survey/servik_icons/reports/243.food.svg": "f0d0",
	"./survey/servik_icons/reports/244.room_conditions.svg": "dfe2",
	"./survey/servik_icons/reports/245.Kindness_sensitivity.svg": "1246",
	"./survey/servik_icons/reports/246.Explain_process.svg": "6f5e",
	"./survey/servik_icons/reports/247.Personal_attention.svg": "d715",
	"./survey/servik_icons/reports/37.like.svg": "2b2c",
	"./survey/servik_icons/reports/39.like.svg": "d0de",
	"./survey/servik_icons/reports/402.services.svg": "ea68",
	"./survey/servik_icons/reports/509.operating_instructions.svg": "83cb",
	"./survey/servik_icons/reports/510.general.svg": "0828",
	"./survey/servik_icons/reports/511.connection_problem.svg": "576d",
	"./survey/servik_icons/reports/512.lighting.svg": "5c74",
	"./survey/servik_icons/reports/54.full_garbage_can.svg": "03b9",
	"./survey/servik_icons/reports/60.status_toilet_paper.svg": "850b",
	"./survey/servik_icons/reports/65.status_head_paper.svg": "4a24",
	"./survey/servik_icons/reports/7.bad_smell.svg": "e576",
	"./survey/servik_icons/reports/70.status_soap.svg": "648b",
	"./survey/servik_icons/reports/75.status_garbage_can.svg": "94d5",
	"./survey/servik_icons/reports/8.dirty_floor.svg": "779e",
	"./survey/servik_icons/reports/80.cleaning.svg": "bd2e",
	"./survey/servik_icons/reports/80.general_cleaning.svg": "04f1",
	"./survey/servik_icons/reports/85.head_coverage.svg": "33ae",
	"./survey/servik_icons/reports/86.something_else.svg": "e3eb",
	"./survey/servik_icons/reports/87.missing_clothing.svg": "7bb7",
	"./survey/servik_icons/reports/9.dirty_lavatory_seat.svg": "b320",
	"./survey/servik_icons/smileys/130.need_improved.svg": "db7b",
	"./survey/servik_icons/smileys/131.liked.svg": "a863",
	"./survey/servik_icons/smileys/132.pleasant.svg": "6eb3",
	"./survey/servik_icons/smileys/36.very_good.svg": "2704",
	"./survey/servik_icons/smileys/37.excellent.svg": "1ef9",
	"./survey/servik_icons/smileys/38.good.svg": "fb85",
	"./survey/servik_icons/smileys/39.like.svg": "b50d",
	"./survey/servik_icons/smileys/40.needs_improvement.svg": "3ebb",
	"./survey/servik_icons/smileys/41.not_good.svg": "1399",
	"./survey/servik_icons/survey/109.professionalism.svg": "41ce",
	"./survey/servik_icons/survey/110.the_attitude_of_the_epresentative.svg": "8ba7",
	"./survey/servik_icons/survey/111.waiting_time_for_service.svg": "cfe8",
	"./survey/servik_icons/survey/112.other_aspect_of_service.svg": "4cb3",
	"./survey/servik_icons/survey/113.language_of_the_service.svg": "53df",
	"./survey/servik_icons/survey/114.rocedure_for_making_an_appointment.svg": "0757",
	"./survey/servik_icons/survey/115.physical_conditions.svg": "6213",
	"./survey/servik_icons/survey/120.found_another.svg": "0049",
	"./survey/servik_icons/survey/121.found_similar.svg": "558d",
	"./survey/servik_icons/survey/122.did_not_find.svg": "ee11",
	"./survey/servik_icons/survey/123.found.svg": "af91",
	"./survey/servik_icons/survey/140.eilat_resident.svg": "d80d",
	"./survey/servik_icons/survey/141.once_a_week.svg": "b1cb",
	"./survey/servik_icons/survey/142.once_a_month.svg": "791d",
	"./survey/servik_icons/survey/143.twice_a_year.svg": "723d",
	"./survey/servik_icons/survey/144.once_a_year.svg": "4a1f",
	"./survey/servik_icons/survey/145.something_else.svg": "c79a",
	"./survey/servik_icons/survey/150.friend.svg": "b56d",
	"./survey/servik_icons/survey/151.newspaper.svg": "99d4",
	"./survey/servik_icons/survey/152.google.svg": "37be",
	"./survey/servik_icons/survey/153.zap.svg": "3327e",
	"./survey/servik_icons/survey/160.vacuum_cleaner.svg": "46ef",
	"./survey/servik_icons/survey/161.gaming_consoles.svg": "df25",
	"./survey/servik_icons/survey/162.laptop.svg": "4ad7",
	"./survey/servik_icons/survey/163.cellular.svg": "7538",
	"./survey/servik_icons/survey/164.shop.svg": "ea14",
	"./survey/servik_icons/survey/165.general_cleaning.svg": "6eb5",
	"./survey/servik_icons/survey/166.restaurant_complex_cleaning.svg": "ffe7",
	"./survey/servik_icons/survey/250.service_problem.svg": "41cc",
	"./survey/servik_icons/survey/251.welcome_you.svg": "738f",
	"./survey/servik_icons/survey/252.invoice_submitted.svg": "d926",
	"./survey/servik_icons/survey/253.thank_you_bought.svg": "1029",
	"./survey/servik_icons/survey/254.problem_seller.svg": "a390",
	"./survey/servik_icons/survey/255.lapel_pin.svg": "8d19",
	"./survey/servik_icons/survey/256.proper_performance.svg": "8ca4",
	"./survey/servik_icons/survey/257.name_tag.svg": "d4b6",
	"./survey/servik_icons/survey/258.operational.svg": "fbce",
	"./survey/servik_icons/survey/259.app_revealed.svg": "c399",
	"./survey/servik_icons/survey/260.register_load.svg": "fdbd",
	"./survey/servik_icons/survey/261.visibility_problem.svg": "cdcb",
	"./survey/servik_icons/survey/262.clean_storefront.svg": "1712",
	"./survey/servik_icons/survey/263.clean_garbage.svg": "17a8",
	"./survey/servik_icons/survey/264.clean_tables_chairs.svg": "3d8e",
	"./survey/servik_icons/survey/265.clean_shop_floor.svg": "c6f4",
	"./survey/servik_icons/survey/266.product_show.svg": "2ca5",
	"./survey/servik_icons/survey/267.refrigerators_show.svg": "82c2",
	"./survey/servik_icons/survey/268.coffee_accessories.svg": "431b",
	"./survey/servik_icons_white/cleaned/1.cleaned_floor.svg": "934c",
	"./survey/servik_icons_white/cleaned/2.cleaned_toilet.svg": "9e73",
	"./survey/servik_icons_white/cleaned/3.cleaned_shower.svg": "b60f",
	"./survey/servik_icons_white/cleaned/4.cleaned_sink.svg": "b23a",
	"./survey/servik_icons_white/cleaned/5.cleaned_mirro.svg": "9688",
	"./survey/servik_icons_white/cleaned/6.cleaned_stainless_steel.svg": "b3fb",
	"./survey/servik_icons_white/counter/45.people_counter.svg": "5862",
	"./survey/servik_icons_white/counter/50.counter.svg": "f740",
	"./survey/servik_icons_white/counter/51.counter_men.svg": "86ff",
	"./survey/servik_icons_white/counter/52.counter_woman.svg": "878c",
	"./survey/servik_icons_white/counter/53.counter_handycap.svg": "d47a",
	"./survey/servik_icons_white/fixed/192.fixed_soap_dispenser.svg": "f4c7",
	"./survey/servik_icons_white/fixed/193.fixed_paper_dispenser.svg": "208f",
	"./survey/servik_icons_white/fixed/194.fixed_coffee_machine.svg": "815a",
	"./survey/servik_icons_white/fixed/195.fixed_water_bar.svg": "bfdc",
	"./survey/servik_icons_white/fixed/27.fixed_shower.svg": "4fac",
	"./survey/servik_icons_white/fixed/28.fixed_sink.svg": "d166",
	"./survey/servik_icons_white/fixed/29.fixed_mirro.svg": "e25c",
	"./survey/servik_icons_white/fixed/30.fixed_stainless_steel.svg": "d320",
	"./survey/servik_icons_white/fixed/31.fixed_blockage.svg": "13305",
	"./survey/servik_icons_white/fixed/32.fixed_door.svg": "aa6a",
	"./survey/servik_icons_white/fixed/33.fixed_fluid_taps.svg": "759a",
	"./survey/servik_icons_white/fixed/34.fixed_lightning.svg": "41fd",
	"./survey/servik_icons_white/fixed/35.fixed_broken_toilet.svg": "c933",
	"./survey/servik_icons_white/food/170.dining_room.svg": "ef3e",
	"./survey/servik_icons_white/food/171.food_variety.svg": "c045",
	"./survey/servik_icons_white/food/172.quality_of_the_food.svg": "0912",
	"./survey/servik_icons_white/food/173.amount_of_the_food.svg": "82e8",
	"./survey/servik_icons_white/food/174.quality_of_cooking.svg": "af51",
	"./survey/servik_icons_white/food/175.side_courses.svg": "f5db",
	"./survey/servik_icons_white/food/176.meat.svg": "2bea",
	"./survey/servik_icons_white/food/177.desserts.svg": "39f8",
	"./survey/servik_icons_white/food/178.vegetarian.svg": "7f2c",
	"./survey/servik_icons_white/food/179.salad_bar.svg": "af64",
	"./survey/servik_icons_white/food/180.main_courses.svg": "e64f",
	"./survey/servik_icons_white/food/181.service.svg": "3341",
	"./survey/servik_icons_white/food/182.dining_room_cleanlines.svg": "8137",
	"./survey/servik_icons_white/food/183.plates_and_cutlery_cleanliness.svg": "29c0",
	"./survey/servik_icons_white/food/184.product_inventory.svg": "9214",
	"./survey/servik_icons_white/food/185.furnichers.svg": "3787",
	"./survey/servik_icons_white/food/186.toilets.svg": "8b13",
	"./survey/servik_icons_white/kitchen/47.zone_is_dirty.svg": "1964",
	"./survey/servik_icons_white/kitchen/612.Appliances.svg": "04cb",
	"./survey/servik_icons_white/kitchen/613.Frodktim.svg": "abc2",
	"./survey/servik_icons_white/kitchen/614.Broken_chair.svg": "ad57",
	"./survey/servik_icons_white/kitchen/615.Broken_abinet.svg": "05f9",
	"./survey/servik_icons_white/kitchen/616.Micro.svg": "1126",
	"./survey/servik_icons_white/kitchen/617.toaster.svg": "9dec",
	"./survey/servik_icons_white/kitchen/618.Clogged_sink_malfunction.svg": "f828",
	"./survey/servik_icons_white/kitchen/619.Coffee_cooling_malfunction.svg": "692e",
	"./survey/servik_icons_white/kitchen/620.No_coffee_beans.svg": "0755",
	"./survey/servik_icons_white/kitchen/621.Machine_ailure.svg": "876a",
	"./survey/servik_icons_white/kitchen/622.That_dirty.svg": "6623",
	"./survey/servik_icons_white/kitchen/623.Dirty_refrigerator.svg": "a58d",
	"./survey/servik_icons_white/kitchen/624.Dirty_ables.svg": "1f93",
	"./survey/servik_icons_white/kitchen/625.Dirty_floor.svg": "6efd",
	"./survey/servik_icons_white/kitchen/626.Plates.svg": "4ecb",
	"./survey/servik_icons_white/kitchen/627.Selver_spone.svg": "5157",
	"./survey/servik_icons_white/kitchen/628.Cold_drinks_cups.svg": "b135",
	"./survey/servik_icons_white/kitchen/629.Hot_drink_cups.svg": "c363",
	"./survey/servik_icons_white/kitchen/631.problem_sink.svg": "ed51",
	"./survey/servik_icons_white/kitchen/632.A_dripping_faucet.svg": "50ef",
	"./survey/servik_icons_white/kitchen/632.problem_lightning.svg": "b2ee",
	"./survey/servik_icons_white/kitchen/81.coffee_tea.svg": "824c",
	"./survey/servik_icons_white/kitchen/82.water_bar.svg": "3d66",
	"./survey/servik_icons_white/kitchen/83.disposable_dishes.svg": "8de8",
	"./survey/servik_icons_white/language/100.hebrew.svg": "52a5",
	"./survey/servik_icons_white/language/100.עברית.svg": "9e8c",
	"./survey/servik_icons_white/language/101.español.svg": "bfbd",
	"./survey/servik_icons_white/language/102.français.svg": "b6b9",
	"./survey/servik_icons_white/language/103.english.svg": "4e93",
	"./survey/servik_icons_white/language/104.русский.svg": "419c",
	"./survey/servik_icons_white/language/105.italiano.svg": "85dc",
	"./survey/servik_icons_white/language/106.አማርኛ.svg": "6d3d",
	"./survey/servik_icons_white/language/107.português.svg": "5e1c",
	"./survey/servik_icons_white/linked/400.room_link.svg": "ed1f",
	"./survey/servik_icons_white/linked/401.floor_link.svg": "c564",
	"./survey/servik_icons_white/officials/42.supervise.svg": "b780",
	"./survey/servik_icons_white/officials/43.maintenance.svg": "1602",
	"./survey/servik_icons_white/officials/44.cleaner.svg": "6286",
	"./survey/servik_icons_white/officials/45.tag_cleaner.svg": "2970",
	"./survey/servik_icons_white/officials/46.zone_is_clean.svg": "4f3c",
	"./survey/servik_icons_white/officials/47.zone_is_dirty.svg": "789a",
	"./survey/servik_icons_white/officials/48.cleaner_arrived.svg": "a321",
	"./survey/servik_icons_white/officials/49.start_clean_zone.svg": "8017",
	"./survey/servik_icons_white/officials/55.maintenance_fixed.svg": "6ac5",
	"./survey/servik_icons_white/officials/56.maintenance_problem.svg": "b65f",
	"./survey/servik_icons_white/officials/59.end_clean_zone.svg": "cd94",
	"./survey/servik_icons_white/problem/18.problem_shower.svg": "84da",
	"./survey/servik_icons_white/problem/187.problem_coffee_machine.svg": "082d",
	"./survey/servik_icons_white/problem/188.problem_water_bar.svg": "4eff",
	"./survey/servik_icons_white/problem/19.problem_sink.svg": "ea06",
	"./survey/servik_icons_white/problem/196.problem_urinals.svg": "230b",
	"./survey/servik_icons_white/problem/197.blockage_toilet.svg": "f66f",
	"./survey/servik_icons_white/problem/198.appliance_problem.svg": "742e",
	"./survey/servik_icons_white/problem/199.problem_broken_door.svg": "be9e",
	"./survey/servik_icons_white/problem/20.problem_mirro.svg": "29b4",
	"./survey/servik_icons_white/problem/200.problem_broken_door_lock.svg": "91e4",
	"./survey/servik_icons_white/problem/200.problem_door_lock.svg": "7f6a",
	"./survey/servik_icons_white/problem/201.problem_broken_toilet_seat.svg": "64b4",
	"./survey/servik_icons_white/problem/202.problem_broken_niagara.svg": "9d3e",
	"./survey/servik_icons_white/problem/203.broken_hand_paper_dispenser_Hand_dryer.svg": "88892",
	"./survey/servik_icons_white/problem/21.problem_stainless_steel.svg": "4cc8",
	"./survey/servik_icons_white/problem/213.problem_bed_smell.svg": "2589",
	"./survey/servik_icons_white/problem/214.problem_broken_toilet_handle.svg": "1238",
	"./survey/servik_icons_white/problem/215.problem_handle_door.svg": "b42b",
	"./survey/servik_icons_white/problem/217.wall_painting.svg": "c7ae",
	"./survey/servik_icons_white/problem/22.problem_blockage.svg": "1bae",
	"./survey/servik_icons_white/problem/220.problem_right_elevator.svg": "871c",
	"./survey/servik_icons_white/problem/221.problem_left_elevator.svg": "969a",
	"./survey/servik_icons_white/problem/223.problem_sink_blockage.svg": "85fe",
	"./survey/servik_icons_white/problem/224.electric_problem.svg": "f783",
	"./survey/servik_icons_white/problem/226.problem_air_condition.svg": "1328",
	"./survey/servik_icons_white/problem/23.problem_door.svg": "ea49",
	"./survey/servik_icons_white/problem/24.problem_fluid_taps.svg": "f88c",
	"./survey/servik_icons_white/problem/25.problem_lightning.svg": "fa76",
	"./survey/servik_icons_white/problem/26.problem_broken_toilet.svg": "a456",
	"./survey/servik_icons_white/problem/56.maintenance_problem.svg": "7ff8",
	"./survey/servik_icons_white/problem/57.problem_soap_dispenser.svg": "7109",
	"./survey/servik_icons_white/problem/58.problem_paper_dispenser.svg": "c512",
	"./survey/servik_icons_white/problem/88.maintenance.svg": "b0c1",
	"./survey/servik_icons_white/reports/10.dirty_shower.svg": "761b",
	"./survey/servik_icons_white/reports/108.partial_Information.svg": "7da8",
	"./survey/servik_icons_white/reports/11.dirty_sink.svg": "fedb",
	"./survey/servik_icons_white/reports/12.dirty_mirror.svg": "850c",
	"./survey/servik_icons_white/reports/13.dirty_stainless_steel.svg": "3d0b",
	"./survey/servik_icons_white/reports/14.missing_paper_towel.svg": "f31d",
	"./survey/servik_icons_white/reports/15.missing_soap.svg": "2cf7",
	"./survey/servik_icons_white/reports/16.missing_toilet_paper.svg": "8e63",
	"./survey/servik_icons_white/reports/190.dirty_stairs.svg": "8fa6",
	"./survey/servik_icons_white/reports/191.missing_toiletries.svg": "b897",
	"./survey/servik_icons_white/reports/191.toiletries.svg": "2f90",
	"./survey/servik_icons_white/reports/196.problem_urinals.svg": "1ab3",
	"./survey/servik_icons_white/reports/197.blockage_toilet.svg": "6e38",
	"./survey/servik_icons_white/reports/199.hand_dryer.svg": "bda6",
	"./survey/servik_icons_white/reports/204.rug.svg": "1f79",
	"./survey/servik_icons_white/reports/205.tables.svg": "7094",
	"./survey/servik_icons_white/reports/206.kitchen.svg": "07b7",
	"./survey/servik_icons_white/reports/207.air_condition.svg": "a95e",
	"./survey/servik_icons_white/reports/208.dirty_urinals.svg": "58b8",
	"./survey/servik_icons_white/reports/208.problem_urinals.svg": "872b",
	"./survey/servik_icons_white/reports/209.blockage_toilet.svg": "54f0",
	"./survey/servik_icons_white/reports/210.hand_dryer.svg": "22f6",
	"./survey/servik_icons_white/reports/212.non-sticky_carpet.svg": "effe",
	"./survey/servik_icons_white/reports/216.call_cleaner.svg": "e6ef",
	"./survey/servik_icons_white/reports/218.missing_paper.svg": "86fa",
	"./survey/servik_icons_white/reports/219.clean_surface.svg": "2edf",
	"./survey/servik_icons_white/reports/222.missing_hend_sanitizer.svg": "7e06",
	"./survey/servik_icons_white/reports/225.missing_coffe_tea.svg": "cddd",
	"./survey/servik_icons_white/reports/227.dishwashing.svg": "f317",
	"./survey/servik_icons_white/reports/228.kitchen_cleanliness.svg": "8af5",
	"./survey/servik_icons_white/reports/229.weekly_cleaning.svg": "a085",
	"./survey/servik_icons_white/reports/230.general_arrangement.svg": "935b",
	"./survey/servik_icons_white/reports/231.meeting_room.svg": "eaf0",
	"./survey/servik_icons_white/reports/232.refrigerator.svg": "94f0",
	"./survey/servik_icons_white/reports/233.kitchen_supplies.svg": "07d1",
	"./survey/servik_icons_white/reports/234.toilet_service.svg": "fe0d",
	"./survey/servik_icons_white/reports/234.toilet_services.svg": "d060",
	"./survey/servik_icons_white/reports/235.carousel_door.svg": "8123",
	"./survey/servik_icons_white/reports/236.desk.svg": "be69",
	"./survey/servik_icons_white/reports/237.compressor.svg": "0f41",
	"./survey/servik_icons_white/reports/238.compressor_rails.svg": "6696",
	"./survey/servik_icons_white/reports/239.compressor_drainage.svg": "6301",
	"./survey/servik_icons_white/reports/240.dust.svg": "b3943",
	"./survey/servik_icons_white/reports/243.food.svg": "fa19",
	"./survey/servik_icons_white/reports/244.room_conditions.svg": "86fad",
	"./survey/servik_icons_white/reports/245.Kindness_sensitivity.svg": "415d",
	"./survey/servik_icons_white/reports/246.Explain_process.svg": "8b83",
	"./survey/servik_icons_white/reports/247.Personal_attention.svg": "9098",
	"./survey/servik_icons_white/reports/37.like.svg": "9366",
	"./survey/servik_icons_white/reports/39.like.svg": "9587",
	"./survey/servik_icons_white/reports/402.services.svg": "b063",
	"./survey/servik_icons_white/reports/509.operating_instructions.svg": "f1a5",
	"./survey/servik_icons_white/reports/510.general.svg": "21b7",
	"./survey/servik_icons_white/reports/511.connection_problem.svg": "4253",
	"./survey/servik_icons_white/reports/512.lighting.svg": "870f",
	"./survey/servik_icons_white/reports/54.full_garbage_can.svg": "3f7b",
	"./survey/servik_icons_white/reports/60.status_toilet_paper.svg": "afa8",
	"./survey/servik_icons_white/reports/65.status_head_paper.svg": "9c4a",
	"./survey/servik_icons_white/reports/7.bad_smell.svg": "08dc",
	"./survey/servik_icons_white/reports/70.status_soap.svg": "84b2",
	"./survey/servik_icons_white/reports/75.status_garbage_can.svg": "2e9c",
	"./survey/servik_icons_white/reports/8.dirty_floor.svg": "7fa0",
	"./survey/servik_icons_white/reports/80.cleaning.svg": "c720",
	"./survey/servik_icons_white/reports/80.general_cleaning.svg": "6759",
	"./survey/servik_icons_white/reports/84.non-sticky_carpet.svg": "8b73",
	"./survey/servik_icons_white/reports/85.head_coverage.svg": "8dbc",
	"./survey/servik_icons_white/reports/86.something_else.svg": "201a",
	"./survey/servik_icons_white/reports/87.missing_clothing.svg": "ebed",
	"./survey/servik_icons_white/reports/9.dirty_lavatory_seat.svg": "1ef7",
	"./survey/servik_icons_white/smileys/130.need_improved.svg": "fbde",
	"./survey/servik_icons_white/smileys/131.liked.svg": "9c14",
	"./survey/servik_icons_white/smileys/132.pleasant.svg": "66f5",
	"./survey/servik_icons_white/smileys/36.very_good.svg": "6fe3",
	"./survey/servik_icons_white/smileys/37.excellent.svg": "f3b8",
	"./survey/servik_icons_white/smileys/38.good.svg": "36fa",
	"./survey/servik_icons_white/smileys/39.like.svg": "ffdc",
	"./survey/servik_icons_white/smileys/40.needs_improvement.svg": "f459",
	"./survey/servik_icons_white/smileys/41.not_good.svg": "2fc6",
	"./survey/servik_icons_white/survey/109.professionalism.svg": "2e7f",
	"./survey/servik_icons_white/survey/110.the_attitude_of_the_epresentative.svg": "7a58",
	"./survey/servik_icons_white/survey/111.waiting_time_for_service.svg": "fa40",
	"./survey/servik_icons_white/survey/112.other_aspect_of_service.svg": "68b7",
	"./survey/servik_icons_white/survey/113.language_of_the_service.svg": "f6c1",
	"./survey/servik_icons_white/survey/114.rocedure_for_making_an_appointment.svg": "ce80",
	"./survey/servik_icons_white/survey/115.physical_conditions.svg": "0e4f",
	"./survey/servik_icons_white/survey/120.found_another.svg": "8892",
	"./survey/servik_icons_white/survey/121.found_similar.svg": "f7c4",
	"./survey/servik_icons_white/survey/122.did_not_find.svg": "a5ea",
	"./survey/servik_icons_white/survey/123.found.svg": "1b0c",
	"./survey/servik_icons_white/survey/140.eilat_resident.svg": "c54d",
	"./survey/servik_icons_white/survey/141.once_a_week.svg": "d46c",
	"./survey/servik_icons_white/survey/142.once_a_month.svg": "9b26",
	"./survey/servik_icons_white/survey/143.twice_a_year.svg": "6ba0",
	"./survey/servik_icons_white/survey/144.once_a_year.svg": "14c1",
	"./survey/servik_icons_white/survey/145.something_else.svg": "5771",
	"./survey/servik_icons_white/survey/150.friend.svg": "7d66",
	"./survey/servik_icons_white/survey/151.newspaper.svg": "d753",
	"./survey/servik_icons_white/survey/152.google.svg": "e729",
	"./survey/servik_icons_white/survey/153.zap.svg": "5074",
	"./survey/servik_icons_white/survey/160.vacuum_cleaner.svg": "a411",
	"./survey/servik_icons_white/survey/161.gaming_consoles.svg": "01e1",
	"./survey/servik_icons_white/survey/162.laptop.svg": "6aef",
	"./survey/servik_icons_white/survey/163.cellular.svg": "a644",
	"./survey/servik_icons_white/survey/164.shop.svg": "841e",
	"./survey/servik_icons_white/survey/165.general_cleaning.svg": "1aa2",
	"./survey/servik_icons_white/survey/166.restaurant_complex_cleaning.svg": "6714",
	"./survey/servik_icons_white/survey/250.service_problem.svg": "55ab",
	"./survey/servik_icons_white/survey/251.welcome_you.svg": "67c8",
	"./survey/servik_icons_white/survey/252.invoice_submitted.svg": "b6e0",
	"./survey/servik_icons_white/survey/253.thank_you_bought.svg": "8830",
	"./survey/servik_icons_white/survey/254.problem_seller.svg": "a4e9",
	"./survey/servik_icons_white/survey/255.lapel_pin.svg": "ed4a",
	"./survey/servik_icons_white/survey/256.proper_performance.svg": "687c",
	"./survey/servik_icons_white/survey/257.name_tag.svg": "47ee",
	"./survey/servik_icons_white/survey/258.operational.svg": "966f",
	"./survey/servik_icons_white/survey/259.app_revealed.svg": "4a3b",
	"./survey/servik_icons_white/survey/260.register_load.svg": "416c",
	"./survey/servik_icons_white/survey/261.visibility_problem.svg": "b103",
	"./survey/servik_icons_white/survey/262.clean_storefront.svg": "d6d9",
	"./survey/servik_icons_white/survey/263.clean_garbage.svg": "9d02",
	"./survey/servik_icons_white/survey/264.clean_tables_chairs.svg": "7480",
	"./survey/servik_icons_white/survey/265.clean_shop_floor.svg": "a286",
	"./survey/servik_icons_white/survey/266.product_show.svg": "9efc",
	"./survey/servik_icons_white/survey/267.refrigerators_show.svg": "016a",
	"./survey/servik_icons_white/survey/268.coffee_accessories.svg": "491e",
	"./upload_icon.svg": "48e4",
	"./warning_blue.svg": "9fed",
	"./warning_orange.svg": "3d12",
	"./warning_red.svg": "f096",
	"./woman.svg": "11b3",
	"./x-icon.svg": "db2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";